import { DownOutlined } from '@ant-design/icons'
import type { ApolloClient } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { Dropdown } from 'antd'
import {
  ScanCenterCode,
  UpdateScanCenterDocument,
  type UpdateScanCenterMutation,
} from '~app/graph/generated/graphql'
import { useUpdatingContext } from '../useUpdatingContext'

/*
 * Hooks
 */

const useScanCenter = (
  sourceId: string
): {
  loading: boolean
  updateScanCenter: (
    newScanCenter: ScanCenterCode
  ) => Promise<ApolloClient.MutateResult<UpdateScanCenterMutation>>
} => {
  const { setUpdating } = useUpdatingContext()
  const [updateScanCenterMutation, { loading }] = useMutation(
    UpdateScanCenterDocument
  )
  return {
    loading,
    updateScanCenter: newScanCenter => {
      setUpdating(sourceId, true)
      return updateScanCenterMutation({
        variables: { id: sourceId, scanCenter: newScanCenter },
      }).finally(() => setUpdating(sourceId, false))
    },
  }
}

/*
 * Component
 */
interface Props {
  sourceId: string
  scanCenterCode: ScanCenterCode
}

const ScanCenter = ({ sourceId, scanCenterCode }: Props) => {
  const { updateScanCenter, loading } = useScanCenter(sourceId)
  return (
    <Dropdown
      disabled={loading}
      menu={{
        items: Object.keys(ScanCenterCode).map(code => ({
          key: code,
          label: code,
        })),
        onClick: ({ key }) => updateScanCenter(ScanCenterCode[key]),
      }}
    >
      <a
        role="button"
        className="ant-dropdown-link"
        onClick={e => e.preventDefault}
      >
        {scanCenterCode} <DownOutlined />
      </a>
    </Dropdown>
  )
}

export default ScanCenter
